import { useCallback, useRef } from 'react'

const wait = (waitMs: number) =>
  new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve()
    }, waitMs)
  })

export const useCircuitBreaker = <Type>(
  countLimit: number,
  intervalMs: number,
  cbFunc: () => void | Promise<Type>,
  onReachLimit: () => void | Promise<void>
): [() => Promise<void | Type>] => {
  const count = useRef(0)

  const increment = () => {
    count.current += 1
  }

  const decrement = () => {
    count.current -= 1
  }

  const send = useCallback(async () => {
    increment()
    if (count.current <= countLimit) {
      return cbFunc()
    }
    await wait(intervalMs)
    if (count.current >= countLimit) {
      onReachLimit()
    }
    decrement()
  }, [countLimit, intervalMs, cbFunc, onReachLimit])

  return [send]
}
